import instanceAxios from '../config/api'
import { SubDomain, SubDomainResponse } from '../types/subDomainTypes'
const API_URL = '/subDomains'

export const getAllSubDomains = async ({
  search,
  page,
  pageSize,
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<SubDomainResponse>(`${API_URL}`, {
      params: {
        page,
        pageSize,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SubDomain.')
  }
}
export const getSubDomainByIdApi = async (id: string) => {
  try {
    const response = await instanceAxios.get<SubDomain>(`${API_URL}/${id}`)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch sub-domain by ID.')
  }
}
export const deleteSubDomainApi = async (SubDomainId: string) => {
  try {
    const response = await instanceAxios.delete<SubDomain[]>(
      `${API_URL}/` + SubDomainId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch subDomains.')
  }
}

export const addSubDomainApi = async (
  newSubDomain: SubDomain
): Promise<SubDomain> => {
  try {
    const response = await instanceAxios.post<SubDomain>(
      `${API_URL}`,
      newSubDomain
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to add SubDomain.')
  }
}

export const getSubDomainbyIdApi = async (SubDomainId: string) => {
  try {
    const response = await instanceAxios.get<SubDomain>(
      `${API_URL}/` + SubDomainId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetchSubDomain.')
  }
}

export const updateSubDomainApi = async (
  updateSubDomain: SubDomain,
  _id: string
): Promise<SubDomain> => {
  try {
    const response = await instanceAxios.put<SubDomain>(
      `${API_URL}/${_id}`,
      updateSubDomain
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUTSubDomain.')
  }
}

export const getSubDomainbySecurityControlsApi = async (
  SecurityControls: string
) => {
  try {
    const response = await instanceAxios.get<SubDomain[]>(
      `securityControls/getSubDomains/` + SecurityControls
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SubDomains.')
  }
}

export const getSubDomainsBySecurityControlIdAndActionIdApi = async (
  actionId: string,
  securityControlId: string
) => {
  try {
    const response = await instanceAxios.get<SubDomain[]>(
      `actions/${actionId}/securityControls/${securityControlId}/subDomains`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SubDomains.')
  }
}
